import React, { useContext } from 'react';
import { themeContext } from 'contexts/theme_context/ThemeContext';
import styles from './LoadingScreen.module.css';

const LOADER_MODES = new Set(['page', 'panel', 'inline']);

function LoadingScreen({
    mode = 'page',
    title = "Getting to Shift EV's Portal",
    message = 'Connecting you with your electric fleet, wherever you are.',
    detail = '',
    ariaLabel,
    className = '',
}) {
    const theme = useContext(themeContext);
    const webtheme = theme?.webtheme === 'dark' ? 'dark' : 'light';
    const resolvedMode = LOADER_MODES.has(mode) ? mode : 'page';
    const rootClassName = [
        styles.loadingScreen,
        styles[resolvedMode],
        styles[webtheme],
        className,
    ].filter(Boolean).join(' ');

    return (
        <div
            className={rootClassName}
            role="status"
            aria-live="polite"
            aria-atomic="true"
            aria-label={ariaLabel}
            data-loader-mode={resolvedMode}
            data-loader-theme={webtheme}
        >
            <div className={styles.visual} aria-hidden="true">
                <div className={styles.mark}>
                    <span className={styles.body}></span>
                    <span className={styles.surge}></span>
                </div>
            </div>
            <div className={styles.content}>
                {title && <p className={styles.title}>{title}</p>}
                {message && <p className={styles.message}>{message}</p>}
                {detail && <p className={styles.detail}>{detail}</p>}
            </div>
        </div>
    );
}

export default LoadingScreen;
